import React from 'react';
import { TextField } from '@mui/material';
import { Field } from 'react-final-form';

const RFFSelect = ({ name, children, ...props }) => (
  <Field name={name}>
    {({ input, meta }) => (
      <TextField
        {...input}
        {...props}
        select
        error={meta.touched && !!meta.error}
        helperText={meta.touched ? meta.error : undefined}
      >
        {children}
      </TextField>
    )}
  </Field>
);

export default RFFSelect;